import type { TopCollectorPageConfig } from '@/app/(football)/[team]/top-collector/_context/types';

export const jbfcConfig: TopCollectorPageConfig = {
  benefit: {
    captions: [
      '상반기 시즌은 2026년 7월 15일 11:00:00에 종료됩니다.',
      '탑콜렉터 순위는 2026 시즌에 발행한 카드만 포함됩니다.',
      '시즌 종료 시점의 순위를 기준으로 혜택이 지급됩니다.',
      '시즌 종료 후 1주 내 대상자에게는 개별 문자 안내됩니다.\n개인 사유로 인한 미수신으로 발생하는 손해에 대해서는\n당사가 책임을 지지 않습니다.',
      '동일 개수일 경우, 먼저 달성한 유저가 상위에 랭크됩니다.',
      '싸인 액자의 경우 1위는 전 선수 싸인 / 2-3위는 선수 1인의 싸인이\n포함된 액자가 전달됩니다. (싸인 희망 선수 선택 가능)',
      '선수 싸인 홈 유니폼은 사이즈 및 선수 마킹 정보를 선택할 수\n있습니다.',
      '순위가 높을수록 싸인 홈 유니폼 선수 우선 선택권이 있습니다.',
      '홈 경기 팬 싸인회 참여권의 경우 두경기 옵션 제공 후 가능 경기를\n선택할 수 있습니다.',
      '빕스 1인 식사권 (2매)는 모바일 기프티콘으로 발송됩니다.',
      '체험 혜택은 2026년 8월 1일 홈 경기에서 제공됩니다.',
      '체험 혜택의 경우 행사 당일 불참 시 참여가 불가합니다.',
      '굿즈 혜택의 경우 행사 당일 불참 시 별도 배송해드립니다.\n주소 오기입으로 인한 피해는 당사가 책임지지 않습니다.',
      '위 삽입된 상품 이미지는 예시이며, 실제 제공 상품과\n디자인·색상·구성 등이 다를 수 있습니다.',
    ],
    // 하반기(second) 유의사항
    secondSeasonCaptions: [
      '하반기 시즌은 2026년 10월 28일(수) 11:00:00에 종료됩니다.',
      '탑콜렉터 순위는 2026 시즌에 발행한 카드만 포함됩니다.',
      '시즌 종료 시점의 순위를 기준으로 혜택이 지급됩니다.',
      '시즌 종료 후 1주 내 대상자에게는 개별 문자 안내됩니다.\n개인 사유로 인한 미수신으로 발생하는 손해에 대해서는\n당사가 책임을 지지 않습니다.',
      '동일 개수일 경우, 먼저 달성한 유저가 상위에 랭크됩니다.',
      '싸인 액자의 경우 1위는 전 선수 싸인 / 2-3위는 선수 1인의 싸인이\n포함된 액자가 전달됩니다. (싸인 희망 선수 선택 가능)',
      '선수 싸인 홈 유니폼은 사이즈 및 선수 마킹 정보를 선택할 수\n있습니다.',
      '순위가 높을수록 싸인 홈 유니폼 선수 우선 선택권이 있습니다.',
      '홈 경기 팬 싸인회 참여권의 경우 두경기 옵션 제공 후 가능 경기를\n선택할 수 있습니다.',
      '빕스 1인 식사권 (2매)는 모바일 기프티콘으로 발송됩니다.',
      '체험 혜택은 스플릿 일정 확정 후 안내되며,\n홈 경기 일정 중 진행됩니다.',
      '체험 혜택의 경우 행사 당일 불참 시 참여가 불가합니다.',
      '굿즈 혜택의 경우 행사 당일 불참 시 별도 배송해드립니다.\n주소 오기입으로 인한 피해는 당사가 책임지지 않습니다.',
      '위 삽입된 상품 이미지는 예시이며, 실제 제공 상품과\n디자인·색상·구성 등이 다를 수 있습니다.',
      '일정 및 혜택 변동 시 본 페이지 팝업 또는 인스타그램을 통해\n사전 안내드립니다.',
    ],
  },
};
